<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; padding: 0 24px; overflow: hidden;">
            <InfinityScroll ref="infinityScroll" :handle-next-page="handleNextPage" :is-enable-next-page-handle="isEnableNextPageHandle" :refresh-action="() => {}" style="height: 100%;">
                <div style="font-size: 28px; font-weight: 700; line-height: 36px; margin-top: 41px; margin-bottom: 40px;">어떤 입단 요청서를<br>수정하시겠어요?</div>
                <div style="padding-bottom: 24px;">
                    <div
                        @click="goToModifyRequest(each, i)"
                        v-for="(each, i) in soccerHows"
                        :key="each.idx + '_' + i"
                        :class="['request_card', { dark: isSecretType(each.type) }]"
                    >
                        <div v-if="isSecretType(each.type)" class="secret_tag">시크릿 입단 요청서</div>
                        <div :class="['card_title', { dark: isSecretType(each.type) }]">{{ each.additional_info_introduce }}</div>
                        <div :class="['card_desc', { dark: isSecretType(each.type) }]">{{ each.contents }}</div>
                        <div :class="['card_date', { dark: isSecretType(each.type) }]">
                            {{ each.insert_date | dotDateStr }}{{ each.update_date && each.update_date !== each.insert_date ? '・수정됨' : '・작성' }} 
                        </div>
                    </div>

                    <div @click="confirmSoccerhowDraft" class="new_request_btn">
                        <span class="plus_icon">+</span>
                        <span style="font-weight: 700; color: #797979;">새 입단 요청서 작성하기</span>
                    </div>
                </div>
            </InfinityScroll>
        </div>
        <CommonConfirmFrame v-if="isShowConfirmPopup" :isShowConfirmPopup="isShowConfirmPopup" :closeConfirmPopup="closeConfirmPopup">
            <div class="confirm_draft_content">
                <div @click="closeConfirmPopup" class="confirm_close_btn">
                    <img style="width: 14px;" :src="require('@/assets/img/x_btn_gray.png')" alt="">
                </div>
                <div class="confirm_icon_wrapper">
                    <img style="width: 17px;" :src="require('@/assets/img/writing_request.png')" alt="">
                </div>
                <div class="confirm_title">작성 중인 요청서가 있어요!</div>
                <div class="confirm_desc">
                    이전에 임시 저장된 내용부터<br>이어서 작성하시겠어요?
                </div>
                <div class="confirm_btn_row">
                    <div @click="deleteDraft" class="confirm_btn_new">새로 작성하기</div>
                    <div @click="writeDefaultInfoForm" class="confirm_btn_continue">이어서 작성하기</div>
                </div>
            </div>
        </CommonConfirmFrame>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import { SOCCER_HOW_TYPE, FORM_MODE } from '@/Constants'
import InfinityScroll from '@/components/common/InfinityScroll'
import CommonConfirmFrame from '@/components/common/CommonConfirmFrame'

export default {
    name: 'ModifyRequestList',
    components: {
        MercenaryHeader,
        InfinityScroll,
        CommonConfirmFrame
    },
    data() {
        return {
            soccerHows: [],
            FORM_MODE: FORM_MODE,
            page: 1,
            isEnableNextPageHandle: true,
            isShowConfirmPopup: false,
            soccerhow_draft: {},
            selectedIndex: -1,
        }
    },
    created() {
        this.getMySoccerHow()
    },
    methods: {
        handleNextPage() {
            this.page++
            this.getMySoccerHow()
        },
        isSecretType() {
            return false
        },
        closeConfirmPopup() {
            this.isShowConfirmPopup = false
        },
        async getMySoccerHow() {
            this.isEnableNextPageHandle = false
            // 타입 바꿔서
            const types = SOCCER_HOW_TYPE.SC_COUNSEL + ',' + SOCCER_HOW_TYPE.SC_JOIN + ',' + SOCCER_HOW_TYPE.SC_JOB
            const parameters = {}
            parameters.page = this.page
            parameters.type = types
            parameters.sort = 'desc'
            parameters.is_except_exit_member = true;
            parameters.writer_idx = this.$GlobalStore.loginInfo().idx
            parameters.writer_type = this.$GlobalStore.loginInfo().member_type

            const res = await this.$Axios.get('/api/soccerhow/list', { params: parameters })
            const soccerHows = res.data.soccerHows
            
            if (soccerHows.length > 0) {
                this.isEnableNextPageHandle = true
                this.soccerHows = [...this.soccerHows, ...soccerHows]
            }
        },
        async confirmSoccerhowDraft() {
            const res = await this.$Axios.get('/api/soccerhow/get/draft')
            if (res.data.soccerhow_draft) {
                this.isShowConfirmPopup = true
                this.soccerhow_draft = res.data.soccerhow_draft
            } else {
                this.selectPlayerType()
            }
        },
        selectPlayerType() {
            this.$GlobalStore.addModal('SelectPlayerType')
        },
        async updateSoccerhow(introduceText, requestText) {
            const originalIntroduceText = this.soccerHows[this.selectedIndex].additional_info_introduce
            const originalRequestText = this.soccerHows[this.selectedIndex].contents

            if (originalIntroduceText !== introduceText) {
                this.$set(this.soccerHows[this.selectedIndex], 'additional_info_introduce', introduceText)
            }
            if (originalRequestText !== requestText) {
                this.$set(this.soccerHows[this.selectedIndex], 'contents', requestText)
            }
            this.$set(this.soccerHows[this.selectedIndex], 'update_date', new Date())
        },
        goToModifyRequest(each, i) {
            this.selectedIndex = i
            this.$GlobalStore.addModal('WriteDefaultInfoForm', { 
                soccerhowIdx: each.idx, 
                mode: FORM_MODE.UPDATE, 
                completeModifyAction: this.updateSoccerhow 
            });
        },
        async deleteDraft() {
            const res = await this.$Axios.post('/api/soccerhow/delete/draft')
            if (res.data.code === 0) {
                this.isShowConfirmPopup = false
                this.selectPlayerType()
            }
        },
        writeDefaultInfoForm() {
            this.isShowConfirmPopup = false
            this.$GlobalStore.addModal('WriteDefaultInfoForm', { soccerhowDraft: this.soccerhow_draft, isDraft: true, playerType: this.soccerhow_draft.player_type })
        },
    }
}   
</script>

<style scoped>
.request_card {
    padding: 24px 12px;
    border-radius: 24px;
    margin-bottom: 20px;
    background: #FF71111A;
    position: relative;
}
.request_card.dark {
    background: linear-gradient(180deg, rgba(33, 15, 3, 0.6) 0%, rgba(80, 80, 90, 0.8) 100%);
}
.request_card.selected {
    border-color: #44A96C;
}
.secret_tag {
    position: absolute;
    top: 12px;
    left: 12px;
    background: #FF7111;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    padding: 4px 8px;
    border-radius: 4px;
}
.card_title {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
}
.card_title.dark {
    color: #fff;
}
.card_desc {
    font-size: 12px;
    line-height: 24px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.card_desc.dark {
    color: rgba(255, 255, 255, 0.9);
}
.card_date {
    font-weight: 700;
    font-size: 12px;
    color: #797979;
    line-height: 24px;
}
.card_date.dark {
    color: rgba(255, 255, 255, 0.7);
}
.new_request_btn {
    margin-top: 16px;
    padding: 24px;
    border: 2px dashed #D9D9D9;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    background: #fff;
}
.new_request_btn .plus_icon {
    font-size: 24px;
    font-weight: 300;
    color: #808080;
}
.new_request_btn span:last-child {
    font-size: 16px;
    font-weight: 500;
    color: #333;
}

.confirm_draft_content {
    position: relative;
    /* min-width: 280px; */
    padding-top: 20px;
}

.confirm_close_btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: 0px 1px 9.1px 0px #00000014;
    cursor: pointer;
}

.confirm_icon_wrapper {
    width: 40px;
    height: 40px;
    margin: 0 auto 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #FF71111A;
}

.confirm_title {
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    margin-bottom: 5px;
}

.confirm_desc {
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #808080;
    margin-bottom: 30px;
}

.confirm_btn_row {
    display: flex;
    gap: 12px;
}

.confirm_btn_new {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    border: 1px solid #210F03;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    flex-basis: 35%;
}

.confirm_btn_continue {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background-color: var(--color-main);
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    flex-basis: 65%;
}
</style>